import { Component, inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ChecklisteFragaModel, GruppWithFragor } from "~app/features/virkeskop/models/checklist-models";
import { ChecklistMediatorService } from "~app/features/virkeskop/services/checklist-mediator.service";

@Component({
    selector: "rask-kontrakt-checklist-fraga",
    imports: [RaskCommonModule],
    templateUrl: "./kontrakt-checklist-fraga.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./kontrakt-checklist-fraga.component.scss"
})
export class KontraktChecklistFragaComponent {
    @Input() fraga: ChecklisteFragaModel;
    @Input() item: GruppWithFragor;
    private readonly checklisteFragorMediator = inject(ChecklistMediatorService);

    onSelectedChanged(fraga: ChecklisteFragaModel, checked: boolean) {
        this.checklisteFragorMediator.onSelectedChanged(fraga, checked);
    }
}
